// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.13520"][{"1962":0}[chunkId]] || "1.13522") + "/" + chunkId + ".js";
};